module.exports = __webpack_public_path__ + "img/3.01a95e6c.png";